import { useEffect, useRef } from "react";

import { useTranslation } from "react-i18next";

import { sileo } from "sileo";

import { useRegisterSW } from "virtual:pwa-register/react";

export function PWAUpdatePrompt() {
  const { t } = useTranslation("common");

  const toastIdRef = useRef<string | null>(null);

  const {
    needRefresh: [needRefresh, setNeedRefresh],

    updateServiceWorker,
  } = useRegisterSW({
    // Chequeo periódico: aunque la PWA quede abierta, revisa si hay un build

    // nuevo cada 15 min. Así los deploys llegan sin depender de reabrir la app

    // ni del ciclo de ~24 h del navegador. Seguimos en modo "prompt": NO recarga

    // solo, solo dispara el toast para que el usuario decida cuándo aplicar.

    onRegisteredSW(swUrl, r) {
      if (!r) return;

      setInterval(
        async () => {
          // No chequear mientras hay un SW instalándose, ni si estamos offline.

          if (r.installing || !navigator) return;

          if ("connection" in navigator && !navigator.onLine) return;

          try {
            const resp = await fetch(swUrl, {
              cache: "no-store",

              headers: { "cache-control": "no-cache" },
            });

            if (resp?.status === 200) await r.update();
          } catch {
            // Sin red o server caído: reintenta en el próximo tick.
          }
        },

        15 * 60 * 1000,
      );
    },

    onRegisterError(err) {
      console.error("[pwa] sw register error", err);
    },
  });

  useEffect(() => {
    if (!needRefresh) return;

    toastIdRef.current = sileo.action({
      title: t("pwaUpdate.title"),

      description: t("pwaUpdate.description"),

      duration: null,

      button: {
        title: t("pwaUpdate.action"),

        onClick: () => {
          setNeedRefresh(false);

          updateServiceWorker(true);
        },
      },
    });

    return () => {
      if (toastIdRef.current) {
        sileo.dismiss(toastIdRef.current);

        toastIdRef.current = null;
      }
    };
  }, [needRefresh, setNeedRefresh, t, updateServiceWorker]);

  return null;
}
